import React from "react";
import {
  AppointmentTask,
  AppointmentTaskStatus,
} from "../../constants/AppointmentOverlayTasks";
import { useJustCompleted } from "./useJustCompleted";

type AppointmentOverlayTaskRowProps = {
  task: AppointmentTask;
  onAction: (task: AppointmentTask) => void;
};

const AppointmentOverlayTaskRow = ({
  task,
  onAction,
}: AppointmentOverlayTaskRowProps) => {
  const isCompleted = task.status === AppointmentTaskStatus.COMPLETED;
  // Being ticked off plays its completion animation.
  const justCompleted = useJustCompleted(isCompleted);

  return (
    <li
      className={`appointment-overlay__task${
        isCompleted ? " appointment-overlay__task--completed" : ""
      }${justCompleted ? " appointment-overlay__task--just-completed" : ""}`}
    >
      <span
        className="appointment-overlay__task-indicator appointment-overlay__task-indicator--static"
        aria-hidden="true"
      >
        {isCompleted && <span className="material-symbols-outlined">check</span>}
      </span>

      <div className="appointment-overlay__task-text">
        <div className="appointment-overlay__task-title">{task.title}</div>
        {task.subtitle && (
          <div className="appointment-overlay__task-subtitle">
            {task.subtitle}
          </div>
        )}
      </div>

      <span className="appointment-overlay__task-end">
        {isCompleted ? (
          <span className="appointment-overlay__task-done">Completed</span>
        ) : (
          task.action && (
            <button
              type="button"
              className="appointment-overlay__task-action"
              onClick={() => onAction(task)}
            >
              {task.action.label}
            </button>
          )
        )}
        {/* While it's marked off, the action fades out where "Completed" fades in. */}
        {justCompleted && task.action && (
          <span
            className="appointment-overlay__task-action appointment-overlay__task-action--leaving"
            aria-hidden="true"
          >
            {task.action.label}
          </span>
        )}
      </span>
    </li>
  );
};

export default React.memo(AppointmentOverlayTaskRow);
